/* Ventrin Growth OS — hidden internal admin shell.
 *
 * Mounted under /admin/growth. Only super_admin users see it. The route
 * deliberately does not appear in the main sidebar; you reach it by
 * typing the URL or via the Profile menu (a "Growth OS" item shown only
 * when role === "super_admin"). */

import { useEffect } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../auth-context";

const NAV = [
  { to: "/admin/growth",                label: "Dashboard",         end: true },
  { to: "/admin/growth/leads",          label: "Leads" },
  { to: "/admin/growth/pipeline",       label: "Pipeline" },
  { to: "/admin/growth/outreach",       label: "Outreach" },
  { to: "/admin/growth/replies",        label: "Replies" },
  { to: "/admin/growth/calls",          label: "Calls" },
  { to: "/admin/growth/pilots",         label: "Pilots" },
  { to: "/admin/growth/reports",        label: "Reports" },
  { to: "/admin/growth/suppression",    label: "Suppression" },
  { to: "/admin/growth/settings",       label: "Settings" },
];

export function GrowthShell() {
  const { profile, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!profile?.user || profile.user.role !== "super_admin") {
      navigate("/", { replace: true });
    }
  }, [loading, profile, navigate]);

  if (loading || profile?.user?.role !== "super_admin") {
    return <div className="sg-empty">Loading…</div>;
  }

  return (
    <div className="sg-growth-root">
      <header className="sg-growth-header">
        <div>
          <div className="sg-growth-eyebrow">Internal · not customer-facing</div>
          <h1 className="sg-growth-title">Growth OS</h1>
        </div>
        <div className="sg-growth-header-meta">
          Outbound platform for Ventrin. Hidden from customers.
        </div>
      </header>

      <nav className="sg-growth-subnav" aria-label="Growth navigation">
        {NAV.map((n) => (
          <NavLink
            key={n.to}
            to={n.to}
            end={n.end}
            className={({ isActive }) => `sg-growth-tab${isActive ? " active" : ""}`}
          >
            {n.label}
          </NavLink>
        ))}
      </nav>

      <main className="sg-growth-main">
        <Outlet />
      </main>
    </div>
  );
}
